import React from "react";

import { graphql } from "gatsby";

import backgroundImageHelper from "./image/backgroundImageHelper";
import RegistryBanner from "../components/banner/registryBanner";

interface KontentItemRegistryBannerProps {
  data: Queries.kontent_item_registry_banner;
}

const KontentItemRegistryBanner: React.FC<KontentItemRegistryBannerProps> = ({ data }) => {
  if (!data || !data.elements) {
    return null;
  }

  const elements = data.elements!;

  const url = (elements.button_url?.value?.length ?? 0) > 0
    ? elements.button_url?.value?.[0]?.id
    : undefined;

  return (
    <RegistryBanner
      title={elements.title?.value || ""}
      description={elements.description?.value || ""}
      buttonText={elements.button_text?.value || ""}
      buttonUrl={url || ""}
      backgroundImageStyle={backgroundImageHelper(
        elements.image?.value?.[0] as Queries.kontent_item_image,
        { w: 1000 },
      )}
    />
  );
};

export const query = graphql`
  fragment KontentItemRegistryBanner on kontent_item_registry_banner {
    id
    system {
      codename
    }
    elements {
      description {
        value
      }
      button_text {
        value
      }
      title {
        value
      }
      button_url {
        value {
          id
        }
      }
      image {
        value {
          ...KontentItemImage
        }
      }
    }
  }
`;

export default KontentItemRegistryBanner;
